import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import {
  FieldContainer,
  FormContainer,
  FieldInput,
  FieldLabel,
  FieldInputContainer,
  FieldLabelContainer,
} from "../../../settings/UpdatePassword/updatePassword.style";
import { IconContainer, UpdateUserWrapper } from "./UpdateUser.style";

import { Form, Field, Formik } from "formik";
import useUser from "../../../hooks/useUser";
import { useStoreWrapper } from "../../../../../store/store";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import {
  UtilityBtn,
  UtilityBtnCancel,
  UtilityBtnUpdate,
} from "../../../settings/Profile/profile/profile.style";
import { AiFillLock, AiFillUnlock } from "react-icons/ai";
import "./Form.styles.css";
import { getChangedValues } from "../../../../../utils/helpers";
import { PERMISSION_LIST } from "../../../../../shared/sharedConstants";
import { updateUserWithEmailSync } from "../../../hooks/updateUserWithEmailSync";
import useSyncLock from "../../../hooks/useSyncLock";
interface IselectedUser {
  selectedUser: {
    assignedUserFacility: string;
    userFullname: string;
    userHandle: string;
    userId: string;
    userRoleName: string;
    status: string;
  };
}
const UpdateUser = ({ selectedUser }: IselectedUser) => {
  const navigate = useNavigate();

  const [userId, setUserId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [hasEditPermission, setHasEditPermission] = useState(false);

  if (!selectedUser?.userId) {
    navigate("/user/users");
  }

  useEffect(() => {
    if (selectedUser) setUserId(selectedUser?.userId);
  }, [selectedUser]);

  const { updateUser, userData } = useUser({ userId });
  const { data: selectedUserData } = userData;
  const { isLoading, mutateAsync: updateUserDetails } = updateUser;
  const { isSyncing, tryLock, unlock } = useSyncLock();

  const {
    setSelectedUser,
    setSelectedUserFacilities,
    selectedUserFacilities,
    selectedUser: _selectedUser,
    userFacilities,
  } = useStoreWrapper((state) => ({
    setSelectedUser: state.setSelectedUser,
    setSelectedUserFacilities: state.setSelectedUserFacilities,
    selectedUser: state.selectedUser,
    userFacilities: state.userFacilities,
    selectedUserFacilities: state.selectedUserFacilities,
  }));

  const initialValues = {
    title: _selectedUser?.title,
    firstName: _selectedUser?.firstName || "",
    lastName: _selectedUser?.lastName || "",
    email: _selectedUser?.email || "",
    username: _selectedUser?.username || "",
  };

  useEffect(() => {
    if (selectedUserData !== undefined) {
      setSelectedUser(selectedUserData?.data?.data?.user);
      setSelectedUserFacilities(selectedUserData?.data?.data?.facilities);
    }
  }, [selectedUserData]);

  const validationSchema = Yup.object({});
  const onSubmitHandler = async (values: any) => {
    if (!tryLock()) return;

    try {
      // remove empty values
      values = Object.fromEntries(
        Object.entries(values).filter(([_, v]) => v !== "")
      );

      let data = getChangedValues(values, _selectedUser);

      data = {
        ...data,
        userId: _selectedUser.userId,
      };

      const response = await updateUserWithEmailSync({
        salesforceContactId: _selectedUser.userId,
        previousEmail: _selectedUser.email,
        newEmail: data.email,
        saveToSalesforce: () => updateUserDetails(data),
      });
      // Keeps the next edit's previous email current, unless another user was selected meanwhile.
      const current = useStoreWrapper.getState().selectedUser;
      if (current?.userId === data.userId) {
        setSelectedUser({ ...current, ...data });
      }
      toast.success(
        response?.data?.message || "User details updated successfully",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
          toastId: "1",
        }
      );
      setIsEdit(false);
    } catch (error: any) {
      console.log({ error });

      toast.error(
        error?.response?.data.message ||
          "Something went wrong, Please try again",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
          toastId: "1",
        }
      );
    } finally {
      unlock();
    }
  };

  useEffect(() => {
    const selectedUserFacilityIds = selectedUserFacilities.map(
      (facility: any) => facility.facilityId
    );

    const sharedFacilities = userFacilities.filter((facility: any) =>
      selectedUserFacilityIds.includes(facility.facilityId)
    );

    const hasPermission = sharedFacilities.some((facility: any) =>
      facility.permissions.accountAdminPermissions.some(
        (perm: any) =>
          perm.apiName ===
            PERMISSION_LIST.UPDATE_USER_DETAILS_FOR_OTHER_USERS &&
          perm.permissionValue
      )
    );

    setHasEditPermission(hasPermission);
  }, [selectedUserFacilities, userFacilities]);

  return (
    <UpdateUserWrapper>
      <FormContainer>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => onSubmitHandler(values)}
          validationSchema={validationSchema}
          enableReinitialize={true}
        >
          <Form className="form_styles">
            <FieldContainer>
              <FieldLabelContainer>
                <FieldLabel htmlFor="title">Title</FieldLabel>
              </FieldLabelContainer>
              <FieldInputContainer>
                <Field
                  type="text"
                  name="title"
                  id="title"
                  disabled={!isEdit}
                  as={FieldInput}
                />
                <IconContainer>
                  {!isEdit ? (
                    <AiFillLock color="grey" size={24} />
                  ) : (
                    <AiFillUnlock color="green" size={24} />
                  )}
                </IconContainer>
              </FieldInputContainer>
            </FieldContainer>

            <FieldContainer>
              <FieldLabelContainer>
                <FieldLabel htmlFor="firstName">First Name</FieldLabel>
              </FieldLabelContainer>
              <FieldInputContainer>
                <Field
                  type="text"
                  name="firstName"
                  id="firstName"
                  disabled={!isEdit}
                  as={FieldInput}
                />
                <IconContainer>
                  {!isEdit ? (
                    <AiFillLock color="grey" size={24} />
                  ) : (
                    <AiFillUnlock color="green" size={24} />
                  )}
                </IconContainer>
              </FieldInputContainer>
            </FieldContainer>
            <FieldContainer>
              <FieldLabelContainer>
                <FieldLabel htmlFor="lastName">Last Name</FieldLabel>
              </FieldLabelContainer>
              <FieldInputContainer>
                <Field
                  type="text"
                  name="lastName"
                  id="lastName"
                  disabled={!isEdit}
                  as={FieldInput}
                />
                <IconContainer>
                  {!isEdit ? (
                    <AiFillLock color="grey" size={24} />
                  ) : (
                    <AiFillUnlock color="green" size={24} />
                  )}
                </IconContainer>
              </FieldInputContainer>
            </FieldContainer>
            <FieldContainer>
              <FieldLabelContainer>
                <FieldLabel htmlFor="email">Email Address</FieldLabel>
              </FieldLabelContainer>
              <FieldInputContainer>
                <Field
                  type="text"
                  name="email"
                  id="email"
                  disabled={!isEdit}
                  as={FieldInput}
                />
                <IconContainer>
                  {!isEdit ? (
                    <AiFillLock color="grey" size={24} />
                  ) : (
                    <AiFillUnlock color="green" size={24} />
                  )}
                </IconContainer>
              </FieldInputContainer>
            </FieldContainer>
            <FieldContainer>
              <FieldLabelContainer>
                <FieldLabel htmlFor="username">User Name</FieldLabel>
              </FieldLabelContainer>
              <FieldInputContainer>
                <Field
                  type="text"
                  name="username"
                  id="username"
                  disabled={!isEdit}
                  as={FieldInput}
                />
                <IconContainer>
                  {!isEdit ? (
                    <AiFillLock color="grey" size={24} />
                  ) : (
                    <AiFillUnlock color="green" size={24} />
                  )}
                </IconContainer>
              </FieldInputContainer>
            </FieldContainer>
            {/* end of field */}

            <FieldContainer>
              <FieldLabelContainer></FieldLabelContainer>
              <FieldInputContainer style={{ display: "flex", gap: "1rem" }}>
                {!isEdit ? (
                  <UtilityBtn
                    onClick={() => setIsEdit(!isEdit)}
                    disabled={
                      !hasEditPermission || selectedUser.status !== "Active"
                    }
                  >
                    Edit
                  </UtilityBtn>
                ) : (
                  <>
                    <UtilityBtnUpdate
                      type="submit"
                      disabled={isLoading || isSyncing}
                    >
                      Update
                    </UtilityBtnUpdate>
                    <UtilityBtnCancel onClick={() => setIsEdit(!isEdit)}>
                      Cancel
                    </UtilityBtnCancel>
                  </>
                )}
              </FieldInputContainer>
            </FieldContainer>
          </Form>
        </Formik>
      </FormContainer>
    </UpdateUserWrapper>
  );
};
export default UpdateUser;
